import React from 'react'
import {Input, Popover, Tabs, Icon} from 'antd'


const {TabPane} = Tabs;

class CategoryTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "all"
        }
    }

    handleChange = (e) => {
        this.setState({
            activeKey: e
        },() => this.props.onCategoryChange(e))
    };

    content = (categories) => {
        return (
            <div className='breadcrum-more-content'>

                <div className='parent-container'>
                    <ul>
                        {categories?.slice(6, categories?.length)?.map((val) => (
                            <li className={val === this.state.activeKey ? 'active-breadcrum' : ''}
                                onClick={() => this.handleChange(val)}>
                                <a>{val}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        )
    };


    render() {
        let {categories} = this.props;
        categories = categories?.length > 5 ? categories?.slice(0, 5) : categories;
        return (
            <div className="category-tabs">
                <Input
                    className="search-input"
                    onChange={(e) => this.props.onSearch(e.target.value)}
                    suffix={<Icon type="search"/>}
                    placeholder="Search Program"
                />
                <Tabs
                    className={`${this.props.noTop ? 'no-top-space-tabs' : ''}`}
                    onChange={this.handleChange}
                    activeKey={this.state.activeKey}
                    /*tabBarExtraContent={
                        <div className='breadcrum-more'>
                            <Popover
                                content={this.content(this.props.categories)}
                                overlayClassName='breadcrum-more-overlay'
                                placement='bottomLeft'
                            >
                                <a className='para-text'>More</a>
                            </Popover>
                        </div>
                    }*/
                >
                    <TabPane tab="All Categories" key="all"/>
                    {categories?.map((category) =>
                        <TabPane tab={category} key={category}/>)}
                </Tabs>
            </div>
        )
    }
}

export default CategoryTabs;
